import _ from 'lodash';
import React, { Component } from 'react';
import { ReactComponent as DownIcon } from '../../assets/svg/chevron-down.svg';

class Filter extends Component {
	constructor(props) {
		super();
		this.state = {
			showSearchDropDown: false,
			activeFilter: props.activeFilter,
			tempActiveFilter: props.activeFilter,
			searchInputFilter: '',
			filters: props.filters,
			isNewFilterApplied: true,
		};
		this.searchDropDownRef = React.createRef();
		this.wrapper = React.createRef();
	}
	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
	};
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	componentWillReceiveProps = (nextProps) => {
		this.setState({
			activeFilter: nextProps.activeFilter,
			filters: this.state.searchInputFilter === '' ? nextProps.filters : this.state.filters,
		});
	};
	handleClickOutside = (event) => {
		if (
			this.searchDropDownRef.current &&
			!this.searchDropDownRef.current.contains(event.target) &&
			this.wrapper.current &&
			!this.wrapper.current.contains(event.target)
		) {
			if (_.has(this.props, 'version') && this.props.version === 'v2') {
				this.setState({
					tempActiveFilter: this.props.activeFilter,
					isNewFilterApplied: true,
				});
			}
			this.setState({
				showSearchDropDown: false,
				searchInputFilter: '',
			});
		}
	};
	toggleSearchDropDown = () => {
		if (!this.state.showSearchDropDown && this.props.onOpen) {
			this.props.onOpen();
		}
		this.setState({
			showSearchDropDown: !this.state.showSearchDropDown,
		});
	};
	toggleSearchType = (e, type) => {
		if (_.has(this.props, 'version') && this.props.version === 'v2') {
			let array;
			if (this.props.isMultipleSelectable === false) {
				array = type === this.state.tempActiveFilter ? '' : type;
			} else {
				array = [...this.state.tempActiveFilter];

				if (array.includes(type) == false) {
					array.push(type);
				} else {
					const index = array.indexOf(type);
					if (index > -1) {
						array.splice(index, 1); // 2nd parameter means remove one item only
					}
				}
			}
			this.setState({
				tempActiveFilter: array,
				isNewFilterApplied: false,
			});
		} else {
			this.props.handleActiveFilter(e, this.props.type, type);
		}
	};
	onChangeIputSearch = (e) => {
		this.setState({
			searchInputFilter: e.target.value,
		});
		let filteredFilters = _.filter(this.props.filters, (item, indx) => {
			return item.name?.toLowerCase().includes(e.target.value.trim().toLowerCase());
		});
		this.setState({
			filters: filteredFilters,
		});
	};
	render() {
		let activeFilter =
			this.state.isNewFilterApplied === false
				? this.state.tempActiveFilter
				: this.props.activeFilter;
		return (
			<>
				<div
					className={
						'filter' +
						(_.has(this.props, 'filterType') && this.props.filterType
							? ' shoots-filter'
							: '') +
						(_.size(activeFilter) > 0 ? ' active' : '')
					}
				>
					<div
						className="filterTitle"
						onClick={(e) => this.toggleSearchDropDown(e)}
						ref={this.wrapper}
					>
						{this.props.label} :{' '}
						{this.props.isMultipleSelectable
							? _.size(activeFilter) == 0
								? 'All'
								: `${
										_.size(
											_.filter(this.props.filters, {
												key: activeFilter[0],
											}),
										) > 0
											? _.filter(this.props.filters, {
													key: activeFilter[0],
											  })[0].name
											: ''
								  }`
							: _.size(activeFilter) === 0 || activeFilter == ''
							? 'All'
							: _.filter(this.props.filters, {
									key: activeFilter,
							  })[0]?.name}
						{this.props.isMultipleSelectable && _.size(activeFilter) - 1 > 0 ? (
							<span className="filter-sub-text">
								{' + ' + (_.size(activeFilter) - 1)}
							</span>
						) : (
							''
						)}
						<b className={this.state.showSearchDropDown ? 'invert' : ''}>
							<DownIcon />
						</b>
					</div>
					{this.state.showSearchDropDown ? (
						<div className="search-dropdown" ref={this.searchDropDownRef}>
							<div className="search-field">
								<input
									placeholder="Search"
									onChange={(e) => this.onChangeIputSearch(e)}
									value={this.state.searchInputFilter}
								/>
							</div>

							{this.props.loading ? (
								<span className="empty-search-filters">Loading...</span>
							) : _.size(this.state.filters) > 0 ? (
								_.map(this.state.filters, (filter, k) => {
									return (
										<a
											className={`item ${
												this.props.isMultipleSelectable
													? _.size(activeFilter) > 0 &&
													  activeFilter.includes(filter.key)
														? 'active'
														: ''
													: activeFilter === filter.key
													? 'active'
													: ''
											}`}
											href
											onClick={(e) => this.toggleSearchType(e, filter.key)}

										>
											<span
												className={`checkbox ${
													this.props.isMultipleSelectable
														? _.size(activeFilter) > 0 &&
														  activeFilter.includes(filter.key)
															? 'active'
															: ''
														: activeFilter === filter.key
														? 'active'
														: ''
												}`}
											></span>
											<span
											style={{
												
												display:"block",
												whiteSpace:"nowrap",
												textOverflow:"ellipsis",
												overflow:"hidden",
											}}
											>
											{filter.name}
											</span>
											
										</a>
									);
								})
							) : (
								<span className="empty-search-filters">
									No {this.props.label} found
								</span>
							)}
							{this.props.isMultipleSelectable &&
							(_.size(activeFilter) > 0 ||
								!_.isEqual(
									this.state.tempActiveFilter,
									this.props.activeFilter,
								)) ? (
								<div className="clear-apply-container">
									<div
										className="clear-field"
										onClick={(e) => {
											if (
												_.has(this.props, 'version') &&
												this.props.version === 'v2'
											) {
												this.setState({
													showSearchDropDown: false,
													tempActiveFilter: [],
													isNewFilterApplied: true,
												});
												if (_.size(this.props.activeFilter) > 0) {
													this.props.clearSelection(e);
												}
											} else {
												this.props.clearSelection(e);
											}
										}}
									>
										Clear
									</div>
									{_.has(this.props, 'version') && this.props.version === 'v2' ? (
										<div
											className="apply-btn"
											onClick={() => {
												if (
													!_.isEqual(
														this.state.tempActiveFilter,
														this.props.activeFilter,
													)
												) {
													this.props.applyFilter(
														this.state.tempActiveFilter,
														this.props.type,
													);
												}
												this.setState({
													isNewFilterApplied: true,
													showSearchDropDown: false,
												});
											}}
										>
											Apply
										</div>
									) : null}
								</div>
							) : this.props.isMultipleSelectable == false &&
							  (activeFilter !== '' ||
									!_.isEqual(
										this.state.tempActiveFilter,
										this.props.activeFilter,
									)) ? (
								<div className="clear-apply-container">
									<div
										className="clear-field"
										onClick={(e) => {
											if (
												_.has(this.props, 'version') &&
												this.props.version === 'v2'
											) {
												this.setState({
													showSearchDropDown: false,
													tempActiveFilter: this.state.activeFilter,
													isNewFilterApplied: true,
												});
												if (_.size(this.props.activeFilter) > 0) {
													this.props.clearSelection(e);
												}
											} else {
												this.props.clearSelection(e);
											}
										}}
									>
										Clear
									</div>
									{_.has(this.props, 'version') && this.props.version === 'v2' ? (
										<div
											className="apply-btn"
											onClick={() => {
												if (
													!_.isEqual(
														this.state.tempActiveFilter,
														this.props.activeFilter,
													)
												) {
													this.props.applyFilter(
														this.state.tempActiveFilter,
														this.props.type,
													);

													this.setState({
														showSearchDropDown: false,
														isNewFilterApplied: true,
													});
												}
											}}
										>
											Apply
										</div>
									) : null}
								</div>
							) : (
								''
							)}
						</div>
					) : (
						''
					)}
				</div>
			</>
		);
	}
}

export default Filter;
